import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../services/api';

function RegisterPage({ onLogin }) {
  const [form, setForm] = useState({ email: '', password: '', nickname: '', platform: 'afreeca' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await authAPI.register(form);
      onLogin(res.data.token, res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || '회원가입에 실패했습니다.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card card">
        <h1>회원가입</h1>
        <p>keunson 서비스에 가입하세요</p>

        {error && <div className="error-msg">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>닉네임 (방송 활동명)</label>
            <input
              type="text"
              name="nickname"
              className="form-input"
              value={form.nickname}
              onChange={handleChange}
              placeholder="방송에서 사용하는 닉네임"
              required
            />
          </div>

          <div className="form-group">
            <label>이메일</label>
            <input
              type="email"
              name="email"
              className="form-input"
              value={form.email}
              onChange={handleChange}
              placeholder="email@example.com"
              required
            />
          </div>

          <div className="form-group">
            <label>비밀번호</label>
            <input
              type="password"
              name="password"
              className="form-input"
              value={form.password}
              onChange={handleChange}
              placeholder="8자 이상"
              minLength={8}
              required
            />
          </div>

          <div className="form-group">
            <label>주 활동 플랫폼</label>
            <select name="platform" className="form-input" value={form.platform} onChange={handleChange}>
              <option value="afreeca">아프리카TV</option>
              <option value="chzzk">치지직</option>
              <option value="youtube">유튜브</option>
            </select>
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? '가입 중...' : '가입하기'}
          </button>
        </form>

        <p style={{ textAlign: 'center', marginTop: 16, color: '#8B8B9E' }}>
          이미 계정이 있으신가요? <Link to="/login">로그인</Link>
        </p>

        <div style={{ textAlign: 'center', marginTop: 12, fontSize: '0.8rem' }}>
          <Link to="/privacy" style={{ color: '#6B6B7E' }}>개인정보처리방침</Link>
          <span style={{ color: '#4B4B5E', margin: '0 8px' }}>|</span>
          <Link to="/terms" style={{ color: '#6B6B7E' }}>서비스 약관</Link>
        </div>
      </div>
    </div>
  );
}

export default RegisterPage;
